/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AccidentCausation} from "../../model/AccidentCausation";
import{NgxSpinnerService} from 'ngx-spinner';
import {AccidentCausationService} from "../../services/accident-causation.service";
import {NgForm} from "@angular/forms";
import {BaseNgFormAdminComponent} from '../../common/base-ngform-admin.component';


@Component({
    selector: 'app-accident-causation',
    templateUrl: './accident-causation.component.html',
    styleUrls: ['./accident-causation.component.less'],
    standalone: false
})
export class AccidentCausationComponent extends BaseNgFormAdminComponent implements OnInit {
  public accidentCausations: AccidentCausation[];
  public isSuperAdmin: boolean = false;
  public isSiteAdmin: boolean = false;

  constructor(private spinnerService: NgxSpinnerService,
              private accidentCaustionService: AccidentCausationService,
              cdr: ChangeDetectorRef) {
    super(cdr);
  }

  ngOnInit() {
    this.getAllCaustions();
  }

  protected reloadData(): void {
    this.getAllCaustions();
  }

  private getAllCaustions(){
    this.spinnerService.show();
    this.accidentCaustionService.getAll().subscribe(value => {
        this.accidentCausations = value;
        this.cdr.detectChanges();
      },
      err => {
        this.spinnerService.hide();
        console.log(err);
        alert(err);
      },
      () => {
        this.spinnerService.hide();
      }
    );
  }

  addNew(caustion: string){
    this.spinnerService.show();
    var newAccidentCausation = new AccidentCausation();
    newAccidentCausation.causation = caustion;

    this.accidentCaustionService.addAccidentCausation(newAccidentCausation).subscribe(retVal=>{
      this.getAllCaustions();
    },(error)=>{
      this.spinnerService.hide();
      if (error.status=='409')
        alert("Duplicate Value(s) found.");
      else
        alert(error.message);
    },()=>{
      this.spinnerService.hide();
      this.returnMessage = 'Adding accident classification finished';
      setTimeout(() => {
        this.returnMessage = '';
      },2000);
    });
  }

  onSubmit(f: NgForm) {
    this.spinnerService.show();
    let count = 0;
    let array = this.getChangedIndex(f);
    var accidentCausationIds = array.filter(function(elem, index, self) {
      return index == self.indexOf(elem);
    });
    if (accidentCausationIds!=null && accidentCausationIds.length>0)
    {
      accidentCausationIds.forEach(vdi=>{
        var accidentCausationChanged = this.accidentCausations.find(x=>x.accidentCausationId === vdi);
        this.accidentCaustionService.updateAccidentCausationById(accidentCausationChanged).subscribe(retValue=>{
          //something here?
        },(error)=>{
          this.spinnerService.hide();
          if (error.status=='409')
            alert("Duplicate Value(s) found.");
          else
            alert(error.message);
          this.returnMessage = '';
          this.getAllCaustions();
          count = 0;
        },()=>{
          count = count + 1;
          if (count>=accidentCausationIds.length) {
            this.clearNgForm();
            count =0;
            this.spinnerService.hide();
          }
        });
      });
    }
    else{
      this.spinnerService.hide();
      alert("No changes to save.");
    }
  }

  private clearNgForm(){
    this.returnMessage = '';
    this.getAllCaustions();
    this.returnMessage = 'Updating accident classification finished';
    setTimeout(() => {
      this.returnMessage = '';
    }, 2000);
  }

}
